import React, { useState } from 'react';
import cx from 'classnames';

import './styles.css';

const CouponSelector = ({
  onApplyCoupon, isInitialyOpen, couponsApplied, error,
}) => {
  const [isOpen, setIsOpen] = useState(isInitialyOpen);

  const toggleIsOpen = () => setIsOpen(!isOpen);

  const handleSubmit = (e) => {
    e.preventDefault();

    onApplyCoupon(e.target.couponCode.value);
  };

  return (
    <section className="coupon-selector">
      <div className={cx('coupon-selector__form', { 'is-open': isOpen })}>
        <button type="button" onClick={toggleIsOpen}>
          Got a Coupon Code?
        </button>
        <form onSubmit={handleSubmit}>
          <label htmlFor="couponCode">
            Enter Promo Code/ Gift Card
            <div className={cx('code-input', { invalid: error.type === 'invalid' })}>
              <input type="text" name="couponCode" placeholder="Promo Code/ Gift Card" />
              <button type="submit" className="fff-btn-secondary">APPLY</button>
            </div>
            {error.message && <p className="error">{error.message}</p>}
          </label>
        </form>
      </div>
      {couponsApplied.length > 0 && (
        <div className="coupon-selector__applied">
          {couponsApplied.map(({ message }) => (
            <div key={message} className="coupon-selector__applied__coupon">
              <p className="title correct">
                {message}
              </p>
              <i className="fas fa-times close" />
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

CouponSelector.defaultProps = {
  applyCoupon: () => {},
  isInitialyOpen: false,
  error: {},
  couponsApplied: [],
};

export default CouponSelector;
